/**
 * Created by Andrey Popov on 15.10.2026
 */

cleverapps.Tool.UI.windows.noFillWindow = displayToolWindow(() => {
    new NoFillWindow(() => { });
});
